
import { Component, Vue } from 'vue-property-decorator'
import { LeakDetailService } from '@/views/leaks/services/LeakDetailService'
import LeakStatusTag from '@/views/leaks/components/LeakStatusTag/index.vue'
import MapNavigation from '@/components/MapNavigation/index.vue'
import 'video.js/dist/video-js.css'
import 'viewerjs/dist/viewer.css'

@Component({
  name: 'LeakDetailPage',
  components: {
    LeakStatusTag,
    MapNavigation,
  }
})
export default class extends Vue {
  private service: LeakDetailService = new LeakDetailService(this.$route, this.$router, this.$refs, this.$message, this.$confirm)

  async created() {
    await this.service.created()
  }

  handleCancel() {
    this.service.handleCancel()
  }

  goToEditPage(type: string) {
    this.service.goToEditPage(type)
  }

  handleDelete() {
    this.service.handleDelete()
  }

  handleCancelReport() {
    this.service.handleCancelReport()
  }

  handleAssign() {
    this.service.handleAssign()
  }

  handleMarkInternalRepair() {
    this.service.handleMarkInternalRepair()
  }

  handleCancelAssign() {
    this.service.handleCancelAssign()
  }

  handleClaim() {
    this.service.handleClaim()
  }

  handleCancelClaim() {
    this.service.handleCancelClaim()
  }

  handleCancelRepair() {
    this.service.handleCancelRepair()
  }

  openNavigation() {
    this.service.openNavigation()
  }

  closeAssignDeptDialog() {
    this.service.assignDeptDialogVisible = false
  }

  confirmAssignDept() {
    this.service.confirmAssignDept()
  }
}
